module.exports = __webpack_public_path__ + "img/sign-84.bc041e2c.png";